import React, { useState } from 'react';
import './DedicatedNetherlands.css';

const DedicatedNetherlands = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شروع',
      price: '۱,۱۰۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon E3',
      ram: '16 GB',
      storage: '2x240 GB SSD',
      features: ['لوکیشن هلند', 'پهنای باند بالا', 'پایدار‌ی عالی', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۱,۸۰۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon E5',
      ram: '32 GB',
      storage: '2x480 GB SSD',
      features: ['لوکیشن هلند', 'پهنای باند بالا', 'پایدار‌ی عالی', 'پشتیبانی ۲۴/۷', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۳,۲۰۰',
      unit: 'هزار تومان / ماه',
      cpu: 'Intel Xeon Gold',
      ram: '64 GB',
      storage: '2x960 GB NVMe',
      features: ['لوکیشن هلند', 'پهنای باند بالا', 'پایدار‌ی عالی', 'پشتیبانی ۲۴/۷', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>سرور اختصاصی هلند | خرید سرور اختصاصی هلند با بهترین قیمت | افراسل</h1>
        <p>خرید سرور اختصاصی هلند با پهنای باند بالا، پایدار‌ی عالی و پشتیبانی ۲۴ ساعته.</p>
        <meta name="description" content="خرید سرور اختصاصی هلند با بهترین قیمت از افراسل. سرور اختصاصی هلند با پهنای باند بالا، پایدار‌ی عالی و پشتیبانی ۲۴/۷." />
      </div>

      <section className="dedicatednetherlands-hero">
        <div className="dedicatednetherlands-hero-bg"></div>
        <div className="wrap">
          <div className="dedicatednetherlands-hero-content">
            <div className="dedicatednetherlands-badge">
              <span className="pulse-dot"></span>
              🇳🇱 سرور اختصاصی هلند
            </div>
            <h1 className="dedicatednetherlands-hero-title">
              سرور اختصاصی <em>هلند</em>
            </h1>
            <p className="dedicatednetherlands-hero-desc">
              سرور اختصاصی هلند با پهنای باند بالا، پایدار‌ی عالی و پشتیبانی ۲۴ ساعته.
              مناسب برای وب‌سایت‌های بین‌المللی و پروژه‌های بزرگ.
            </p>
            <div className="dedicatednetherlands-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">هلند</span>
                <span className="stat-label">لوکیشن</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="dedicatednetherlands-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های سرور اختصاصی هلند</span>
            <h2 className="sec-h">پلن <em>مناسب</em> کسب‌وکار خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع سرور اختصاصی هلند با قیمت‌های رقابتی.</p>
          </div>
          <div className="dedicatednetherlands-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`dedicatednetherlands-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="dedicatednetherlands-popular-badge">پرفروش‌ترین</span>}
                <div className="dedicatednetherlands-plan-tier">{plan.tier}</div>
                <div className="dedicatednetherlands-plan-price">
                  <span className="dedicatednetherlands-plan-num">{plan.price}</span>
                  <span className="dedicatednetherlands-plan-unit">{plan.unit}</span>
                </div>
                <div className="dedicatednetherlands-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="dedicatednetherlands-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="dedicatednetherlands-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="dedicatednetherlands-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              سرور اختصاصی <em>هلند</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید سرور اختصاصی هلند، از پهنای باند بالا، پایدار‌ی عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید سرور</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DedicatedNetherlands;
